module.exports = __webpack_public_path__ + "static/media/20.b58afb1b.png";